<template>
    <div class="row create-permission-group-block mt-4">
        <div class="col-xl-8 col-xxl-6 col-lg-9 col-md-12 p-lr-0-sm multisteps-form">
            <form class="multisteps-form__form dis-flex flex-column" @submit.prevent="createNewPermissionGroup()">
                <div class="card p-3 dis-flex flex-column mb-4 multisteps-form__content col-sm-12">
                    <div class="row">
                        <div class="col-sm-12 p-lr-0-sm">
                            <div class="dis-flex flex-column col-12 p-0">
                                <div class="dis-flex flex-sb">
                                    <div class="dis-flex col-5 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 p-0">
                                        <i class="uis uis-sitemap mr-2 text-rose"></i>
                                        <h5 class="text-sm-b">Create Group</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-4">
                                <div class="col-sm-10 p-lr-0-sm mb-4">
                                    <label>Group name</label>
                                    <input class="multisteps-form__input form-control" placeholder="Group Name" type="text" v-model="createPermissionGroup.group_name">
                                </div>
                                <div class="col-sm-10 p-lr-0-sm mb-2">
                                    <label>Short Description</label>
                                    <textarea class="small-txt-area w-full" placeholder="eg. Standard permissions for administrators" maxlength="100" type="text" cols="7" rows="2" v-model="createPermissionGroup.group_description"></textarea>
                                    <span class="fs-9 text-rose txt-italic pos-absolute p-r-15 p-lr-0-sm" style="right: 0px;">Max Symbols 100</span>
                                </div>
                                <div class="col-sm-2 p-lr-0-sm dis-flex flex-r flex-b mb-2 mt-4">
                                    <button class="btn button-create-atrb-btn ml-auto" type="button" title="Create permission group" :disabled="!canCreatePermGroup()" @click="createNewPermissionGroup()">Create</button>
                                </div>
                            </div>    
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
    props: {
        permissionsGroupsList: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            createPermissionGroup: {
                group_name: '',
                group_description: ''
            }
        }
    },
    methods: {
        createNewPermissionGroup() {
            let newGroupID = Math.floor(Math.random() * 100000000) + 100000
            let newPermGroupData = JSON.parse(JSON.stringify(this.createPermissionGroup))
            let sendData = {
                group_name: newPermGroupData.group_name,
                group_description: newPermGroupData.group_description
            }
            this.permissionsGroupsList[`${newGroupID}`] = {
                group_id: newGroupID,
                group_name: newPermGroupData.group_name,
                group_description: newPermGroupData.group_description,
                group_permissions: {}
            }

            let alertMixin = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', Swal.stopTimer)
                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                }
            });

            socket.emit('permissions:createPermissionGroup', sendData, (data) => {
                if (data.response == true) {
                    alertMixin.fire({
                        icon: 'success',
                        title: data.message
                    });
                } else {
                    alertMixin.fire({
                        icon: 'error',
                        title: data.error
                    });
                }
                this.$emit('getPermissionsGroups')
            });

            this.createPermissionGroup.group_name = ''
            this.createPermissionGroup.group_description = ''
        },
        canCreatePermGroup() {
            if (this.createPermissionGroup.group_name.length <= 0) {
                return false
            }

            return true
        }
    }
}
</script>

<style>

</style>